<template>
    <div class="summaryC">
        <div class="C_one fx">
            <div class="c_left">
                <div class="c_left_item prel mb02 wow animate__fadeInLeftBig">
                    <img src="@/assets/computer/hexin/lh1.png" class="ig">
                    <img src="@/assets/computer/hexin/z132.png" class="topicon">
                    <div class="text1 fs_01 fw_5">一站式服务</div>
                    <div class="text2 fs_007 lh012 color2">数字创意展示工程，信息化技术软件开发，多媒体展项应用集大成者，为客户提供一站式数字展厅解决方案和策划、设计、实施一体化服务。</div>
                </div>
                <div class="c_left_item prel wow animate__fadeInLeftBig">
                    <img src="@/assets/computer/hexin/lh1.png" class="ig">
                    <img src="@/assets/computer/hexin/z132.png" class="topicon">
                    <div class="text1 fs_01 fw_5">广泛业务范围 </div>
                    <div class="text2 fs_007 lh012 color2">十多年的专业服务经验，服务各领域诸多经典展览展示项目;信息化技术软件开发业务夏盖城市治理、工业制造、文旅产业、教育培训等领域。</div>
                </div>
            </div>
            <div class="c_center">
                <div class=" prel  wow animate__fadeInDown">
                    <div class="ig mt01 ">
                        <img src="@/assets/computer/hexin/ty16.png" class=" c_cicon1">
                        <img src="@/assets/computer/hexin/ty12.png" class=" c_cicon2">
                        <img src="@/assets/computer/hexin/ty13.png" class=" c_cicon3">
                        <img src="@/assets/computer/hexin/ty14.png" class=" c_cicon4">
                        <img src="@/assets/computer/hexin/dp.png" class=" c_cicon5">
                    </div>
                    <img src="@/assets/computer/hexin/z112.png" class=" c_zicon1">
                    <img src="@/assets/computer/hexin/z113.png" class=" c_zicon2">
                    <img src="@/assets/computer/hexin/z114.png" class=" c_zicon3">
                    <img src="@/assets/computer/hexin/z115.png" class=" c_zicon4">
                    
                </div>
                <div>
                </div>
            </div>
            <div class="c_right">
                <div class="c_right_item prel mb02 wow  animate__fadeInRightBig">
                    <img src="@/assets/computer/hexin/lh2.png" class="ig">
                    <img src="@/assets/computer/hexin/z132.png" class="topicon">
                    <div class="text1 fs_01 fw_5">一流设计团队</div>
                    <div class="text2 fs_007 lh012 color2">专业服务团队，拥有一批行业专家与工程师精英人才队伍同时与国内多家985院校以及科研机构达成长期深度战略合作。</div>
                </div>
                <div class="c_right_item prel wow  animate__fadeInRightBig">
                    <img src="@/assets/computer/hexin/lh2.png" class="ig">
                    <img src="@/assets/computer/hexin/z132.png" class="topicon">
                    <div class="text1 fs_01 fw_5">及时运维服务</div>
                    <div class="text2 fs_007 lh012 color2">公司拥有强大的售后运维工程师团队，为客户提供全方位的及时、高效、稳定的售后服务。</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

 import { useRouter } from 'vue-router'
 import {ref, nextTick, onMounted, reactive,defineProps } from "vue";
 import { Swiper } from 'swiper/vue';
 const router = useRouter()


onMounted(() => {
 
});

</script>

<style scoped>
.C_one{
    width: 85%;
    margin: 0 auto 1rem;
}
.c_left{
    width: 25%;
    margin-right: 5%;
}
.topicon{
    width: 0.35rem;
    position: absolute;
    top: 0.3rem;
    left: 0.13rem;
}
.text1{
    position: absolute;
    top: 0.8rem;
    left: 0.13rem;
}
.text2{
    position: absolute;
    top: 1rem;
    left: 0.13rem;
    width: 90%;
}
.c_center{
    width: 35%;
    margin: 0 2.5%;
}
.c_right{
    width: 25%;
    margin-left: 5%;
}

.c_cicon1{
    width: 3rem;
    height: 3rem;
    position: absolute;
    top: 0;
    left: 0;

    transition: all ;
    animation-name: icon1animtran;
    animation-duration: 2.5s;
    /*动画持续时间*/
    /* animation-fill-mode: forwards; */
    /*动画填充模式，forwards作用是将动画的样式停留在最后一个 */
    animation-direction: normal;
    /*规定是否应该轮流反向播放动画。*/
    animation-iteration-count: infinite;
    /*规定动画的速度曲线。*/
    /* animation-timing-function: cubic-bezier(1, 1, 1, 1); */
    /*速度 */
}
@keyframes icon1animtran{
    /* 0%{
        width: 2.5rem;
        height: 2.5rem;
        position: absolute;
        top: 0.25rem;
        left: 0.25rem;
    }100%{
        width: 3rem;
        height: 3rem;
        position: absolute;
        top: 0;
        left: 0;
    } */
    0% {
    transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
}
.c_cicon2{
    width: 2.4rem;
    height: 2.4rem;
    position: absolute;
    top: 0.3rem;
    left: 0.3rem;

    transition: all ;
    animation-name: icon2animtran;
    animation-duration: 2.5s;
    /*动画持续时间*/
    /* animation-fill-mode: forwards; */
    /*动画填充模式，forwards作用是将动画的样式停留在最后一个 */
    animation-direction: normal;
    /*规定是否应该轮流反向播放动画。*/
    animation-iteration-count: infinite;
    /*规定动画的速度曲线。*/
    /* animation-timing-function: cubic-bezier(1, 1, 1, 1); */
    /*速度 */
}
@keyframes icon2animtran{
    /* 0%{
        width: 2rem;
        height: 2rem;
        position: absolute;
        top: 0.5rem;
        left: 0.5rem;
    }100%{
        width: 2.4rem;
        height: 2.4rem;
        position: absolute;
        top: 0.3rem;
        left: 0.3rem;
    } */
    0% {
    transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
}
.c_cicon3{
    width: 2.1rem;
    height: 2.1rem;
    position: absolute;
    top: 0.45rem;
    left: 0.45rem;

    transition: all ;
    animation-name: icon3animtran;
    animation-duration: 2.5s;
    /*动画持续时间*/
    /* animation-fill-mode: forwards; */
    /*动画填充模式，forwards作用是将动画的样式停留在最后一个 */
    animation-direction: normal;
    /*规定是否应该轮流反向播放动画。*/
    animation-iteration-count: infinite;
    /*规定动画的速度曲线。*/
    /* animation-timing-function: cubic-bezier(1, 1, 1, 1); */
    /*速度 */
}
@keyframes icon3animtran{
    /* 0%{
        width: 1.7rem;
        height: 1.7rem;
        position: absolute;
        top: 0.65rem;
        left: 0.65rem;
    }100%{
        width: 1.9rem;
        height: 1.9rem;
        position: absolute;
        top: 0.55rem;
        left: 0.55rem;
    } */
    0% {
    transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
}
.c_cicon4{
    width: 1.4rem;
    height: 1.4rem;
    position: absolute;
    top: 0.8rem;
    left: 0.8rem;
    transition: all ;
    animation-name: icon3animtran;
    animation-duration: 2.5s;
    /*动画持续时间*/
    /* animation-fill-mode: forwards; */
    /*动画填充模式，forwards作用是将动画的样式停留在最后一个 */
    animation-direction: normal;
    /*规定是否应该轮流反向播放动画。*/
    animation-iteration-count: infinite;
    /*规定动画的速度曲线。*/
    /* animation-timing-function: cubic-bezier(1, 1, 1, 1); */
    /*速度 */
}
@keyframes icon3animtran{
    /* 0%{
        width: 1.7rem;
        height: 1.7rem;
        position: absolute;
        top: 0.65rem;
        left: 0.65rem;
    }100%{
        width: 1.9rem;
        height: 1.9rem;
        position: absolute;
        top: 0.55rem;
        left: 0.55rem;
    } */
    0% {
    transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
}
.c_cicon5{
    width: 0.6rem;
    height: auto;
    position: absolute;
    top: 1.1rem;
    left: 1.2rem;
}

.c_zicon1{
    width: 0.8rem;
    height: auto;
    position: absolute;
    top: 0.6rem;
    left: 0.1rem;
}.c_zicon2{
    width: 0.8rem;
    height: auto;
    position: absolute;
    top: 2.2rem;
    left: 0.1rem;
}.c_zicon3{
    width: 0.8rem;
    height: auto;
    position: absolute;
    top: 0.6rem;
    right: 0.1rem;
}.c_zicon4{
    width: 0.8rem;
    height: auto;
    position: absolute;
    top: 2.2rem;
    right: 0.1rem;
}

</style>
